(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["skrt-bestseller-length"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('skrt-bestseller-length')) {
    class SkrtBestsellerLength extends HTMLElement {
      #observer;
      #controller;
      #frame;

      connectedCallback() {
        this.#controller = new AbortController();
        const options = { signal: this.#controller.signal };
        this.addEventListener('change', () => this.#refresh(), options);
        // Concept inserts a new picker next to the old one on every variant change.
        // Observe direct children only, not the accessible description added below.
        this.#observer = new MutationObserver(() => this.#refresh());
        this.#observer.observe(this, { childList: true });
        this.#frame = requestAnimationFrame(() => this.#refresh());
      }

      disconnectedCallback() {
        this.#controller?.abort();
        this.#observer?.disconnect();
        cancelAnimationFrame(this.#frame);
      }

      #refresh() {
        const picker = this.querySelector(':scope > variant-picker');
        if (!picker) return;
        const position = Number(this.dataset.optionPosition);
        if (![1, 2, 3].includes(position)) return;
        const group = picker.querySelector(`fieldset[data-option-index="option${position}"]`);
        if (!group) return;
        const inputs = [...group.querySelectorAll('input[type="radio"]')];
        const winner = inputs.find(input => input.value === this.dataset.value);
        const selected = inputs.find(input => input.checked);
        const available = winner && !winner.disabled && !winner.classList.contains('disabled');
        const label = winner?.nextElementSibling;
        const button = available && label?.matches('label.label-swatch') ? label : null;

        for (const prior of group.querySelectorAll('.skrt-bestseller-length__button')) {
          if (prior === button) continue;
          prior.classList.remove('skrt-bestseller-length__button');
          for (const node of prior.querySelectorAll('[data-bestseller-decoration]')) node.remove();
        }

        if (button && !button.classList.contains('skrt-bestseller-length__button')) {
          button.classList.add('skrt-bestseller-length__button');
          const description = document.createElement('span');
          description.className = 'sr-only';
          description.dataset.bestsellerDecoration = '';
          description.textContent = `, ${this.dataset.accessibleLabel}`;
          button.append(description);
        }

        const valueLabel = group.querySelector(`[id$="-option${position}"]`);
        if (valueLabel && selected) {
          valueLabel.setAttribute('aria-live', 'polite');
          valueLabel.setAttribute('aria-atomic', 'true');
          const message = button && selected === winner ? ` - ${this.dataset.label}` : '';
          if (valueLabel.textContent !== selected.value + message) {
            valueLabel.replaceChildren(document.createTextNode(selected.value));
            if (message) {
              const suffix = document.createElement('span');
              suffix.className = 'skrt-bestseller-length__message';
              suffix.textContent = message;
              valueLabel.append(suffix);
            }
          }
        }
      }
    }
    customElements.define('skrt-bestseller-length', SkrtBestsellerLength);
  }
  } catch(e) { console.error(e); }
})();

})();
